<script>

/**
 * Vue: Ingrid returns modal (ingrid-returns-modal)
 * -----------------------------------------------------------------------------
 * Modal that displays the Ingrid Returns iframe.
 * - Static section.
 *
 */
export default {
  name: 'IngridReturnsModal',

  data() {
    return {
      cnvsStatic: true,
    }
  },
}
</script>

<style lang="scss">
@import './ingrid-returns-modal';
</style>
